const liverpool = [
  {
    id: 1,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2025",
      "2025 liverpool",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/25-26-01/uni0.jpg",
      "/images/europa/liverpool/25-26-01/uni1.jpg",
      "/images/europa/liverpool/25-26-01/uni2.jpg",
      "/images/europa/liverpool/25-26-01/uni3.jpg",
      "/images/europa/liverpool/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2025",
      "2025 liverpool",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/25-26-02/uni0.jpg",
      "/images/europa/liverpool/25-26-02/uni1.jpg",
      "/images/europa/liverpool/25-26-02/uni2.jpg",
      "/images/europa/liverpool/25-26-02/uni3.jpg",
      "/images/europa/liverpool/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2025",
      "2025 liverpool",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/25-26-03/uni0.png",
      "/images/europa/liverpool/25-26-03/uni1.png",
      "/images/europa/liverpool/25-26-03/uni2.png",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 25/26 - Uniforme 4",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2025",
      "2025 liverpool",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/25-26-04/uni0.png",
      "/images/europa/liverpool/25-26-04/uni1.png",
      "/images/europa/liverpool/25-26-04/uni2.png",
      "/images/europa/liverpool/25-26-04/uni3.png",
      "/images/europa/liverpool/25-26-04/uni4.png",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 25/26 - Uniforme de Goleiro (Preta)",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2025",
      "2025 liverpool",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/25-26-05-gp/uni0.png",
      "/images/europa/liverpool/25-26-05-gp/uni1.png",
      "/images/europa/liverpool/25-26-05-gp/uni2.png",
      "/images/europa/liverpool/25-26-05-gp/uni3.png",
      "/images/europa/liverpool/25-26-05-gp/uni4.png",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 25/26 - Uniforme de Goleiro (Verde)",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2025",
      "2025 liverpool",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/25-26-05-gv/uni0.png",
      "/images/europa/liverpool/25-26-05-gv/uni1.png",
      "/images/europa/liverpool/25-26-05-gv/uni2.png",
      "/images/europa/liverpool/25-26-05-gv/uni3.png",
      "/images/europa/liverpool/25-26-05-gv/uni4.png",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2025",
      "2025 liverpool",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/25-26-00-es/uni0.png",
      "/images/europa/liverpool/25-26-00-es/uni1.png",
      "/images/europa/liverpool/25-26-00-es/uni2.png",
      "/images/europa/liverpool/25-26-00-es/uni3.png",
      "/images/europa/liverpool/25-26-00-es/uni4.png",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2024",
      "2024 liverpool",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/24-25-01/uni0.png",
      "/images/europa/liverpool/24-25-01/uni1.jpg",
      "/images/europa/liverpool/24-25-01/uni2.jpg",
      "/images/europa/liverpool/24-25-01/uni3.jpg",
      "/images/europa/liverpool/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2024",
      "2024 liverpool",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/24-25-02/uni0.jpg",
      "/images/europa/liverpool/24-25-02/uni1.jpg",
      "/images/europa/liverpool/24-25-02/uni2.jpg",
      "/images/europa/liverpool/24-25-02/uni3.jpg",
      "/images/europa/liverpool/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 24/25 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2024",
      "2024 liverpool",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/24-25-03/uni0.jpg",
      "/images/europa/liverpool/24-25-03/uni1.jpg",
      "/images/europa/liverpool/24-25-03/uni2.jpg",
      "/images/europa/liverpool/24-25-03/uni3.jpg",
      "/images/europa/liverpool/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 24/25 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2024",
      "2024 liverpool",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/24-25-00-es/uni0.jpg",
      "/images/europa/liverpool/24-25-00-es/uni1.jpg",
      "/images/europa/liverpool/24-25-00-es/uni2.jpg",
      "/images/europa/liverpool/24-25-00-es/uni3.jpg",
      "/images/europa/liverpool/24-25-00-es/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 23/24 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2023",
      "2023 liverpool",
      "2023",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/23-24-03/uni0.jpg",
      "/images/europa/liverpool/23-24-03/uni1.jpg",
      "/images/europa/liverpool/23-24-03/uni2.jpg",
      "/images/europa/liverpool/23-24-03/uni3.jpg",
      "/images/europa/liverpool/23-24-03/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 21/22 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2021",
      "2021 liverpool",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/21-22-02/uni0.jpg",
      "/images/europa/liverpool/21-22-02/uni1.jpg",
      "/images/europa/liverpool/21-22-02/uni2.jpg",
      "/images/europa/liverpool/21-22-02/uni3.jpg",
      "/images/europa/liverpool/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 13/14 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2013",
      "2013 liverpool",
      "2013",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/13-14-01-rt/uni0.jpg",
      "/images/europa/liverpool/13-14-01-rt/uni1.jpg",
      "/images/europa/liverpool/13-14-01-rt/uni2.jpg",
      "/images/europa/liverpool/13-14-01-rt/uni3.jpg",
      "/images/europa/liverpool/13-14-01-rt/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 10/11 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2010",
      "2010 liverpool",
      "2010",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/10-11-02-rt/uni0.jpg",
      "/images/europa/liverpool/10-11-02-rt/uni1.jpg",
      "/images/europa/liverpool/10-11-02-rt/uni2.jpg",
      "/images/europa/liverpool/10-11-02-rt/uni3.jpg",
      "/images/europa/liverpool/10-11-02-rt/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 08/09 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2008",
      "2008 liverpool",
      "2008",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/08-09-01-rt/uni0.jpg",
      "/images/europa/liverpool/08-09-01-rt/uni1.jpg",
      "/images/europa/liverpool/08-09-01-rt/uni2.jpg",
      "/images/europa/liverpool/08-09-01-rt/uni3.jpg",
      "/images/europa/liverpool/08-09-01-rt/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 06/07 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2006",
      "2006 liverpool",
      "2006",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/06-07-01-rt/uni0.jpg",
      "/images/europa/liverpool/06-07-01-rt/uni1.jpg",
      "/images/europa/liverpool/06-07-01-rt/uni2.jpg",
      "/images/europa/liverpool/06-07-01-rt/uni3.jpg",
      "/images/europa/liverpool/06-07-01-rt/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 06/07 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2006",
      "2006 liverpool",
      "2006",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/06-07-02-rt/uni0.jpg",
      "/images/europa/liverpool/06-07-02-rt/uni1.jpg",
      "/images/europa/liverpool/06-07-02-rt/uni2.jpg",
      "/images/europa/liverpool/06-07-02-rt/uni3.jpg",
      "/images/europa/liverpool/06-07-02-rt/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 01/02 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 2001",
      "2001 liverpool",
      "2001",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/01-02-02-rt/uni0.jpg",
      "/images/europa/liverpool/01-02-02-rt/uni1.jpg",
      "/images/europa/liverpool/01-02-02-rt/uni2.jpg",
      "/images/europa/liverpool/01-02-02-rt/uni3.jpg",
      "/images/europa/liverpool/01-02-02-rt/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 99/00 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 1999",
      "1999 liverpool",
      "1999",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/99-00-02-rt/uni0.jpg",
      "/images/europa/liverpool/99-00-02-rt/uni1.jpg",
      "/images/europa/liverpool/99-00-02-rt/uni2.jpg",
      "/images/europa/liverpool/99-00-02-rt/uni3.jpg",
      "/images/europa/liverpool/99-00-02-rt/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 98/99 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 1998",
      "1998 liverpool",
      "1998",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/98-99-02-rt/uni0.jpg",
      "/images/europa/liverpool/98-99-02-rt/uni1.jpg",
      "/images/europa/liverpool/98-99-02-rt/uni2.jpg",
      "/images/europa/liverpool/98-99-02-rt/uni3.jpg",
      "/images/europa/liverpool/98-99-02-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 97/98 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 1997",
      "1997 liverpool",
      "1997",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/97-98-01-rt/uni0.png",
      "/images/europa/liverpool/97-98-01-rt/uni1.png",
      "/images/europa/liverpool/97-98-01-rt/uni2.png",
      "/images/europa/liverpool/97-98-01-rt/uni3.png",
      "/images/europa/liverpool/97-98-01-rt/uni4.png",
    ],
  },
  {
    id: 23,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 96/97 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 1996",
      "1996 liverpool",
      "1996",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/96-97-01-rt/uni0.jpg",
      "/images/europa/liverpool/96-97-01-rt/uni1.jpg",
      "/images/europa/liverpool/96-97-01-rt/uni2.jpg",
      "/images/europa/liverpool/96-97-01-rt/uni3.jpg",
      "/images/europa/liverpool/96-97-01-rt/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 95/96 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 1995",
      "1995 liverpool",
      "1995",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/95-96-01-rt/uni0.jpg",
      "/images/europa/liverpool/95-96-01-rt/uni1.jpg",
      "/images/europa/liverpool/95-96-01-rt/uni2.jpg",
      "/images/europa/liverpool/95-96-01-rt/uni3.jpg",
      "/images/europa/liverpool/95-96-01-rt/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool 81/82 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool 1981",
      "1981 liverpool",
      "1981",
      "liverpool retrô",
      "retrô liverpool",
      "retrô",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/liverpool/81-82-01-rt/uni0.jpg",
      "/images/europa/liverpool/81-82-01-rt/uni1.jpg",
      "/images/europa/liverpool/81-82-01-rt/uni2.jpg",
      "/images/europa/liverpool/81-82-01-rt/uni3.jpg",
      "/images/europa/liverpool/81-82-01-rt/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool - Jaqueta (Branca)",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool jaqueta",
      "jaqueta liverpool",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/jb/uni0.png",
      "/images/europa/liverpool/jb/uni1.png",
      "/images/europa/liverpool/jb/uni2.png",
      "/images/europa/liverpool/jb/uni3.png",
      "/images/europa/liverpool/jb/uni4.png",
    ],
  },
  {
    id: 27,
    pais: "europa",
    liga: "premier-league",
    time: "liverpool",
    nome: "Liverpool - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "liverpool",
      "the reds",
      "liverpool jaqueta",
      "jaqueta liverpool",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/liverpool/jp/uni0.jpg",
      "/images/europa/liverpool/jp/uni1.jpg",
      "/images/europa/liverpool/jp/uni2.jpg",
      "/images/europa/liverpool/jp/uni3.jpg",
      "/images/europa/liverpool/jp/uni4.jpg",
    ],
  },
];

export default liverpool;
